// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { get, post } from "../../lib/http";
// import { API } from "../../config/api";
// import { toast } from "react-toastify";

// /* ----------------- helpers ----------------- */
// const fmtInr = (n = 0) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
// const uuid = () =>
//     "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
//         const r = (Math.random() * 16) | 0,
//             v = c === "x" ? r : (r & 0x3) | 0x8;
//         return v.toString(16);
//     });

// const Text = ({ label, ...props }) => (
//     <div className="space-y-1">
//         <label className="block text-xs font-medium text-slate-600">{label}</label>
//         <input
//             {...props}
//             className={`w-full rounded-xl border px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-amber-300 ${props.className || ""}`}
//         />
//     </div>
// );

// const Select = ({ label, children, ...props }) => (
//     <div className="space-y-1">
//         <label className="block text-xs font-medium text-slate-600">{label}</label>
//         <select
//             {...props}
//             className="w-full rounded-xl border bg-white px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-amber-300"
//         >
//             {children}
//         </select>
//     </div>
// );

// const Chip = ({ tone = "slate", children }) => {
//     const tones = {
//         slate: "bg-slate-50 text-slate-700 ring-slate-200",
//         green: "bg-emerald-50 text-emerald-700 ring-emerald-200",
//         amber: "bg-amber-50 text-amber-700 ring-amber-200",
//         red: "bg-rose-50 text-rose-700 ring-rose-200",
//         blue: "bg-blue-50 text-blue-700 ring-blue-200",
//     };
//     return (
//         <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${tones[tone]}`}>
//             {children}
//         </span>
//     );
// };

// /* ----------------- success modal ----------------- */
// function SuccessModal({ open, onClose, onNew, onView, summary }) {
//     if (!open) return null;
//     return (
//         <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center">
//             {/* backdrop */}
//             <div
//                 onClick={onClose}
//                 className="absolute inset-0 bg-black/40 animate-[fadeIn_200ms_ease-out]"
//             />
//             {/* modal */}
//             <div
//                 className="relative w-full sm:w-[520px] m-0 sm:m-4 rounded-2xl bg-white shadow-xl
//                    animate-[popIn_220ms_cubic-bezier(0.22,1,0.36,1)]"
//             >
//                 <div className="p-6">
//                     <div className="flex items-start gap-3">
//                         <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-100">
//                             <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-emerald-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                                 <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
//                             </svg>
//                         </div>
//                         <div className="min-w-0">
//                             <h3 className="text-lg font-semibold text-slate-900">Cash booking issued!</h3>
//                             <p className="mt-1 text-sm text-slate-600">
//                                 Tickets have been generated{summary?.buyer?.email ? <> and emailed to <b>{summary.buyer.email}</b></> : ""}.
//                             </p>
//                         </div>
//                     </div>

//                     <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
//                         <div className="rounded-lg border p-3">
//                             <div className="text-slate-500">Event</div>
//                             <div className="font-semibold text-slate-900 truncate">{summary?.eventName || "-"}</div>
//                         </div>
//                         <div className="rounded-lg border p-3">
//                             <div className="text-slate-500">Booking Code</div>
//                             <div className="font-semibold text-slate-900 truncate">{summary?.bookingCode || summary?.bookingId || "-"}</div>
//                         </div>
//                         <div className="rounded-lg border p-3">
//                             <div className="text-slate-500">Tickets</div>
//                             <div className="font-semibold text-slate-900">{summary?.totalTickets ?? 0}</div>
//                         </div>
//                         <div className="rounded-lg border p-3">
//                             <div className="text-slate-500">Amount</div>
//                             <div className="font-semibold text-slate-900">
//                                 ₹{Number(summary?.amount || 0).toLocaleString("en-IN")}
//                             </div>
//                         </div>
//                     </div>

//                     {summary?.buyer?.mobile && (
//                         <div className="mt-3 text-xs text-slate-500">
//                             SMS/WhatsApp can be sent to <b>{summary.buyer.mobile}</b> (if configured).
//                         </div>
//                     )}

//                     <div className="mt-6 flex flex-col-reverse sm:flex-row gap-2">
//                         <button
//                             onClick={onNew}
//                             className="inline-flex flex-1 justify-center rounded-xl border px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
//                         >
//                             New Cash Booking
//                         </button>
//                         <button
//                             onClick={onView}
//                             className="inline-flex flex-1 justify-center rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-slate-800"
//                         >
//                             View Booking
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* keyframes (scoped) */}
//             <style>{`
//         @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
//         @keyframes popIn {
//           0% { opacity: 0; transform: translateY(16px) scale(.96) }
//           100% { opacity: 1; transform: translateY(0) scale(1) }
//         }
//       `}</style>
//         </div>
//     );
// }

// /* ----------------- main ----------------- */
// export default function AdminCashBooking() {
//     const navigate = useNavigate();

//     // events + selection
//     const [events, setEvents] = useState([]);
//     const [eventId, setEventId] = useState("");
//     const [event, setEvent] = useState(null);
//     const [loadingEvent, setLoadingEvent] = useState(false);

//     // user
//     const [buyer, setBuyer] = useState({ name: "", email: "", mobile: "" });

//     // lines
//     const [lines, setLines] = useState([
//         { categoryId: "", price: "", quantity: 1, hintSeats: null, userPriceOverride: false },
//     ]);

//     // discount / notes / idempotency
//     const [discount, setDiscount] = useState({ code: "", mode: "flat", value: "" });
//     const [notes, setNotes] = useState("");
//     const [idKey, setIdKey] = useState(uuid());

//     const [submitting, setSubmitting] = useState(false);

//     // success modal
//     const [successOpen, setSuccessOpen] = useState(false);
//     const [successSummary, setSuccessSummary] = useState(null);

//     /* ------------- fetch events list ------------- */
//     useEffect(() => {
//         let on = true;
//         (async () => {
//             try {
//                 const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//                 const data = await get(API.events.getEvent || API.events.list || "/api/events", {
//                     headers: { Authorization: token ? `Bearer ${token}` : undefined },
//                 }).catch(() => ({ events: [] }));
//                 const arr = data?.events || data || [];
//                 if (!on) return;
//                 setEvents(arr);
//             } catch {
//                 setEvents([]);
//             }
//         })();
//         return () => { on = false; };
//     }, []);

//     /* ------------- fetch single event when chosen ------------- */
//     useEffect(() => {
//         if (!eventId) { setEvent(null); return; }
//         let on = true;
//         (async () => {
//             try {
//                 setLoadingEvent(true);
//                 const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//                 const data = await get(`${API.events.getSinglEvent}/${eventId}`, {
//                     headers: { Authorization: token ? `Bearer ${token}` : undefined },
//                 });
//                 if (!on) return;
//                 setEvent(data?.event || null);
//                 const first = data?.event?.ticketCategories?.[0];
//                 setLines([{
//                     categoryId: first?.type || "",
//                     price: first?.price || "",
//                     quantity: 1,
//                     hintSeats: first?.availableSeats ?? null,
//                     userPriceOverride: false,
//                 }]);
//             } catch {
//                 setEvent(null);
//             } finally {
//                 setLoadingEvent(false);
//             }
//         })();
//         return () => { on = false; };
//     }, [eventId]);

//     const categories = useMemo(() => event?.ticketCategories || [], [event]);

//     /* ------------- line updates (auto-price sync) ------------- */
//     const updateLine = (i, patch) => {
//         setLines((prev) => {
//             const next = [...prev];
//             const merged = { ...next[i], ...patch };

//             if ("categoryId" in patch) {
//                 const evCat = categories.find((c) => c.type === patch.categoryId);
//                 merged.price = evCat?.price ?? "";
//                 merged.hintSeats = evCat?.availableSeats ?? null;
//                 merged.userPriceOverride = false;
//             }
//             if ("price" in patch) merged.userPriceOverride = true;
//             if ("quantity" in patch) merged.quantity = Math.max(1, Number(merged.quantity || 1));

//             next[i] = merged;
//             return next;
//         });
//     };

//     const removeLine = (i) => setLines((prev) => prev.filter((_, idx) => idx !== i));

//     /* ------------- totals ------------- */
//     const subtotal = useMemo(
//         () => lines.reduce((s, l) => s + Number(l.quantity || 0) * Number(l.price || 0), 0),
//         [lines]
//     );

//     const discountRaw = Number(discount.value || 0);
//     const percent = discount.mode === "percent" ? Math.max(0, Math.min(100, discountRaw)) : 0;
//     const discountValue =
//         discount.mode === "percent"
//             ? Math.round((subtotal * percent) / 100)
//             : Math.max(0, Math.min(subtotal, Number(discount.value || 0)));
//     const total = Math.max(0, subtotal - discountValue);

//     /* ------------- client validation ------------- */
//     const valid =
//         eventId &&
//         lines.length > 0 &&
//         lines.every((l) => l.categoryId && Number(l.quantity) > 0 && Number(l.price) >= 0) &&
//         ((buyer.email && /\S+@\S+\.\S+/.test(buyer.email)) || (buyer.mobile && /^\d{10}$/.test(buyer.mobile)));

//     /* ------------- submit ------------- */
//     const onSubmit = async (e) => {
//         e.preventDefault();
//         if (!valid) { toast.error("Please complete required fields properly."); return; }
//         setSubmitting(true);
//         try {
//             const token = JSON.parse(localStorage.getItem("bb_user"))?.token;

//             const payload = {
//                 user: { name: buyer.name, email: buyer.email, mobile: buyer.mobile },
//                 eventId,
//                 categories: lines.map((l) => ({
//                     categoryId: l.categoryId,
//                     quantity: Number(l.quantity || 0),
//                     price: Number(l.price || 0),
//                 })),
//                 discount:
//                     discountValue > 0
//                         ? {
//                             code: discount.code || undefined,
//                             value: discountValue,
//                             meta: discount.mode === "percent" ? { mode: "percent", raw: discountRaw } : undefined,
//                         }
//                         : undefined,
//                 notes: notes || undefined,
//                 idempotencyKey: idKey,
//             };

//             const resp = await post(API.Payment.createCashBooking, payload, {
//                 headers: {
//                     Authorization: token ? `Bearer ${token}` : undefined,
//                     "Content-Type": "application/json",
//                 },
//             });

//             if (resp?.success) {
//                 toast.success(resp.idempotent ? "Already issued (idempotent)" : "Cash booking created!");

//                 const booking = resp.booking || {};
//                 const tickets = resp.tickets || {};
//                 const eventName =
//                     booking?.eventId?.name ||
//                     events.find((e) => (e._id || e.id) === eventId)?.name ||
//                     "";

//                 const totalTickets =
//                     (tickets?.ticketCategories || []).reduce(
//                         (sum, c) => sum + Number(c.finalQuantity || 0),
//                         0
//                     ) || 0;

//                 setSuccessSummary({
//                     eventName,
//                     bookingCode: booking?.bookingCode,
//                     bookingId: booking?._id,
//                     amount: resp?.payment?.finalAmount ?? booking?.finalAmount ?? 0,
//                     buyer: { name: buyer.name, email: buyer.email, mobile: buyer.mobile },
//                     totalTickets,
//                 });
//                 setSuccessOpen(true);

//                 // We won't reset immediately; we'll do it when "New Cash Booking" is clicked.
//             } else {
//                 throw new Error(resp?.message || "Failed to create cash booking");
//             }
//         } catch (err) {
//             toast.error(err?.message || "Something went wrong");
//         } finally {
//             setSubmitting(false);
//             // refresh key so even if user retries, it's unique
//             setIdKey(uuid());
//         }
//     };

//     // reset all fields helper
//     const resetForm = (resetEventToo = true) => {
//         setBuyer({ name: "", email: "", mobile: "" });
//         setNotes("");
//         setDiscount({ code: "", mode: "flat", value: "" });
//         setLines([{ categoryId: "", price: "", quantity: 1, hintSeats: null, userPriceOverride: false }]);
//         setIdKey(uuid());
//         if (resetEventToo) {
//             setEventId("");
//             setEvent(null);
//         } else {
//             // if keeping event, also resync lines to first category if available
//             const first = event?.ticketCategories?.[0];
//             if (first) {
//                 setLines([{
//                     categoryId: first.type,
//                     price: first.price || "",
//                     quantity: 1,
//                     hintSeats: first?.availableSeats ?? null,
//                     userPriceOverride: false,
//                 }]);
//             }
//         }
//     };

//     return (
//         <form onSubmit={onSubmit} className="mx-auto max-w-6xl">
//             {/* Page header */}
//             <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
//                 <div>
//                     <h1 className="text-2xl font-bold text-slate-900">Cash Booking</h1>
//                     <p className="text-sm text-slate-600">Issue tickets from the counter & record payment</p>
//                 </div>
//                 {/* <div className="flex items-center gap-2">
//           <Chip tone="blue">Idempotency: {idKey.slice(0, 8)}…</Chip>
//           <button
//             type="button"
//             onClick={() => setIdKey(uuid())}
//             className="rounded-full border px-3 py-1.5 text-sm hover:bg-slate-50"
//           >
//             New Key
//           </button>
//           <button
//             type="submit"
//             disabled={!valid || submitting}
//             className={`rounded-full px-5 py-2 text-sm font-semibold text-white shadow-sm transition ${
//               valid && !submitting ? "bg-amber-500 hover:bg-amber-400" : "bg-slate-300 cursor-not-allowed"
//             }`}
//           >
//             {submitting ? "Issuing…" : "Issue Tickets"}
//           </button>
//         </div> */}
//                 <div className="flex items-center gap-2">
//                     <Chip tone="blue">Idempotency: {idKey.slice(0, 8)}…</Chip>

//                     <button
//                         type="button"
//                         onClick={() => setIdKey(uuid())}
//                         className="rounded-full border px-3 py-1.5 text-sm hover:bg-slate-50"
//                     >
//                         New Key
//                     </button>

//                     {/* NEW: View All Bookings */}
//                     <button
//                         type="button"
//                         onClick={() => navigate("/admin/bookings")}
//                         className="rounded-full border px-3 py-1.5 text-sm hover:bg-slate-50"
//                         title="View all bookings"
//                     >
//                         View All Bookings
//                     </button>

//                     <button
//                         type="submit"
//                         disabled={!valid || submitting}
//                         className={`rounded-full px-5 py-2 text-sm font-semibold text-white shadow-sm transition ${valid && !submitting ? "bg-amber-500 hover:bg-amber-400" : "bg-slate-300 cursor-not-allowed"
//                             }`}
//                     >
//                         {submitting ? "Issuing…" : "Issue Tickets"}
//                     </button>
//                 </div>
//             </div>

//             {/* layout */}
//             <div className="grid gap-6 lg:grid-cols-[1fr_380px]">
//                 {/* LEFT: form */}
//                 <div className="space-y-6">
//                     {/* Event */}
//                     <div className="rounded-2xl border bg-white p-5">
//                         <div className="mb-3 flex items-center justify-between">
//                             <h2 className="text-base font-semibold text-slate-900">Event</h2>
//                             {loadingEvent && <span className="text-xs text-slate-500">loading…</span>}
//                         </div>
//                         <Select label="Select event" value={eventId} onChange={(e) => setEventId(e.target.value)}>
//                             <option value="">— Choose an event —</option>
//                             {events.map((ev) => (
//                                 <option key={ev._id || ev.id} value={ev._id || ev.id}>
//                                     {ev.name || ev.title}
//                                 </option>
//                             ))}
//                         </Select>

//                         {event && (
//                             <div className="mt-4 flex flex-wrap items-center gap-2 text-sm">
//                                 <Chip>{formatEventDateTime(event.date)}</Chip>
//                                 {event.venue?.name && <Chip tone="green">{event.venue.name}</Chip>}
//                                 {event.status && <Chip tone="amber">{event.status}</Chip>}
//                             </div>
//                         )}
//                     </div>

//                     {/* Buyer */}
//                     <div className="rounded-2xl border bg-white p-5">
//                         <h2 className="mb-3 text-base font-semibold text-slate-900">Buyer</h2>
//                         <div className="grid gap-4 sm:grid-cols-3">
//                             <Text label="Full Name" placeholder="e.g. Rohan Singh" value={buyer.name}
//                                 onChange={(e) => setBuyer((b) => ({ ...b, name: e.target.value }))} />
//                             <Text label="Email" type="email" placeholder="you@example.com" value={buyer.email}
//                                 onChange={(e) => setBuyer((b) => ({ ...b, email: e.target.value }))} />
//                             <Text label="Mobile (10-digit)" inputMode="numeric" maxLength={10} placeholder="98XXXXXXXX"
//                                 value={buyer.mobile}
//                                 onChange={(e) => setBuyer((b) => ({ ...b, mobile: e.target.value.replace(/\D/g, "").slice(0, 10) }))} />
//                         </div>
//                         <p className="mt-2 text-xs text-slate-500">Need at least email or mobile to deliver tickets.</p>
//                     </div>

//                     {/* Lines */}
//                     <div className="rounded-2xl border bg-white p-5">
//                         <div className="mb-3 flex items-center justify-between">
//                             <h2 className="text-base font-semibold text-slate-900">Ticket Categories</h2>
//                         </div>

//                         <div className="space-y-3">
//                             {lines.map((l, i) => {
//                                 const evCat = categories.find((c) => c.type === l.categoryId);
//                                 const seatLeft = evCat?.availableSeats ?? l.hintSeats;
//                                 const over = seatLeft != null && Number(l.quantity || 0) > Number(seatLeft);

//                                 return (
//                                     <div key={i} className="rounded-xl border p-4">
//                                         <div className="grid gap-3 sm:grid-cols-[1.3fr_1fr_1fr_auto] sm:items-end">
//                                             <Select label="Category" value={l.categoryId} onChange={(e) => updateLine(i, { categoryId: e.target.value })}>
//                                                 <option value="">— choose —</option>
//                                                 {categories.map((c) => (
//                                                     <option key={c.type} value={c.type}>
//                                                         {c.type} {c.price ? `• ${fmtInr(c.price)}` : ""}
//                                                     </option>
//                                                 ))}
//                                             </Select>

//                                             <Text label="Price (each)" type="number" min="0" value={l.price}
//                                                 onChange={(e) => updateLine(i, { price: e.target.value })} />

//                                             <Text label="Quantity" type="number" min="1" value={l.quantity}
//                                                 onChange={(e) => updateLine(i, { quantity: e.target.value })} />

//                                             <div className="flex items-center justify-between gap-3">
//                                                 <div className="text-sm font-semibold text-slate-900">
//                                                     {fmtInr((Number(l.price || 0) * Number(l.quantity || 0)) || 0)}
//                                                 </div>
//                                                 <button type="button" onClick={() => removeLine(i)}
//                                                     className="rounded-full border px-3 py-1.5 text-xs text-rose-600 hover:bg-rose-50">
//                                                     Remove
//                                                 </button>
//                                             </div>
//                                         </div>

//                                         <div className="mt-2 flex items-center justify-between text-xs">
//                                             <div className="space-x-2">
//                                                 {seatLeft != null && <Chip tone={over ? "red" : "slate"}>Seats left: {seatLeft}</Chip>}
//                                                 {evCat?.perks?.length ? <Chip tone="blue">{evCat.perks.join(", ")}</Chip> : null}
//                                                 {l.userPriceOverride && <Chip tone="amber">price overridden</Chip>}
//                                             </div>
//                                             {over && <div className="text-rose-600 font-medium">Insufficient seats in this category</div>}
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                         </div>
//                     </div>

//                     {/* Discount / Notes */}
//                     <div className="rounded-2xl border bg-white p-5">
//                         <h2 className="mb-3 text-base font-semibold text-slate-900">Discount & Notes</h2>
//                         <div className="grid gap-4 sm:grid-cols-4">
//                             <Text label="Discount Code (optional)" value={discount.code}
//                                 onChange={(e) => setDiscount((d) => ({ ...d, code: e.target.value }))} />
//                             <Select label="Mode" value={discount.mode}
//                                 onChange={(e) => setDiscount((d) => ({ ...d, mode: e.target.value }))}>
//                                 <option value="flat">Flat (₹)</option>
//                                 <option value="percent">Percent (%)</option>
//                             </Select>
//                             <Text label={discount.mode === "percent" ? "Discount (%)" : "Discount Amount (₹)"}
//                                 type="number" min="0" max={discount.mode === "percent" ? "100" : undefined}
//                                 value={discount.value}
//                                 onChange={(e) => setDiscount((d) => ({ ...d, value: e.target.value }))} />
//                             <Text label="Notes (internal)" value={notes} onChange={(e) => setNotes(e.target.value)} />
//                         </div>
//                         {discount.mode === "percent" && !!discount.value && (
//                             <p className="mt-2 text-xs text-slate-600">
//                                 Applying {Math.max(0, Math.min(100, Number(discount.value || 0)))}% on {fmtInr(subtotal)} → <b>{fmtInr(discountValue)}</b>
//                             </p>
//                         )}
//                     </div>
//                 </div>

//                 {/* RIGHT: summary */}
//                 <aside className="space-y-6">
//                     <div className="rounded-2xl border bg-white p-5">
//                         <h3 className="mb-4 text-base font-semibold text-slate-900">Review</h3>
//                         <div className="space-y-3 text-sm">
//                             <div className="flex items-center justify-between">
//                                 <span className="text-slate-600">Subtotal</span>
//                                 <span className="font-semibold text-slate-900">{fmtInr(subtotal)}</span>
//                             </div>
//                             <div className="flex items-center justify-between">
//                                 <span className="text-slate-600">Discount</span>
//                                 <span className="font-semibold text-emerald-700">− {fmtInr(discountValue)}</span>
//                             </div>
//                             <div className="border-t pt-3 flex items-center justify-between">
//                                 <span className="text-slate-900 font-semibold">Total</span>
//                                 <span className="text-lg font-bold text-slate-900">{fmtInr(total)}</span>
//                             </div>
//                         </div>

//                         <div className="mt-4 rounded-xl bg-slate-50 p-3 text-xs text-slate-600">
//                             <ul className="list-disc pl-4 space-y-1">
//                                 <li>Payment method recorded as <b>cash</b>.</li>
//                                 <li>Tickets & PDF emailed if buyer email is provided.</li>
//                                 <li>Idempotency prevents duplicate issue if you re-submit.</li>
//                             </ul>
//                         </div>

//                         <button
//                             type="submit"
//                             disabled={!valid || submitting}
//                             className={`mt-4 w-full rounded-xl px-4 py-2 text-sm font-semibold text-white shadow-sm ${valid && !submitting ? "bg-slate-900 hover:bg-slate-800" : "bg-slate-300 cursor-not-allowed"
//                                 }`}
//                         >
//                             {submitting ? "Issuing…" : "Confirm & Issue"}
//                         </button>
//                     </div>

//                     {event && (
//                         <div className="rounded-2xl border bg-white p-5">
//                             <h3 className="mb-3 text-base font-semibold text-slate-900">Availability</h3>
//                             <div className="space-y-2">
//                                 {event.ticketCategories?.map((c) => (
//                                     <div key={c.type} className="flex items-center justify-between text-sm">
//                                         <span className="text-slate-700">{c.type}</span>
//                                         <div className="flex items-center gap-2">
//                                             <Chip tone="green">{fmtInr(c.price)}</Chip>
//                                             <Chip tone={(c.availableSeats ?? 0) > 0 ? "slate" : "red"}>
//                                                 {c.availableSeats ?? 0} left
//                                             </Chip>
//                                         </div>
//                                     </div>
//                                 ))}
//                                 {!event.ticketCategories?.length && (
//                                     <div className="text-sm text-slate-500">No ticket categories configured.</div>
//                                 )}
//                             </div>
//                         </div>
//                     )}
//                 </aside>
//             </div>

//             {/* success modal */}
//             <SuccessModal
//                 open={successOpen}
//                 summary={successSummary}
//                 onClose={() => setSuccessOpen(false)}
//                 onNew={() => {
//                     setSuccessOpen(false);
//                     resetForm(true); // pass false if you want to keep selected event
//                 }}
//                 onView={() => {
//                     setSuccessOpen(false);
//                     if (successSummary?.bookingId) {
//                         navigate(`/admin/bookings/${successSummary.bookingId}`, { replace: true });
//                     } else {
//                         navigate(`/admin/bookings`, { replace: true });
//                     }
//                 }}
//             />
//         </form>
//     );
// }



import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { get, post } from "../../../lib/http";
import { API } from "../../../config/api";
import { toast } from "react-toastify";
import { AD } from "../../adminUi.js";
import { formatEventDateTime } from "../../../utils/datetime.js";

const cn = (...a) => a.filter(Boolean).join(" ");

/* ----------------- helpers ----------------- */
const fmtInr = (n = 0) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
const uuid = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

const Text = ({ label, ...props }) => (
  <label className="block">
    <span className={AD.fieldLabel}>{label}</span>
    <input {...props} className={cn(AD.inputField, "mt-1", props.className)} />
  </label>
);

const Select = ({ label, children, ...props }) => (
  <label className="block">
    <span className={AD.fieldLabel}>{label}</span>
    <select {...props} className={cn(AD.select, "mt-1")}>
      {children}
    </select>
  </label>
);

const Chip = ({ tone = "slate", children }) => {
  const tones = {
    slate: "bg-slate-50 text-slate-700 ring-slate-200",
    green: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    amber: "bg-amber-50 text-amber-700 ring-amber-200",
    red: "bg-rose-50 text-rose-700 ring-rose-200",
    blue: "bg-blue-50 text-blue-700 ring-blue-200",
  };
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${tones[tone]}`}>
      {children}
    </span>
  );
};

/* ----------------- success modal ----------------- */
function SuccessModal({ open, onClose, onNew, onView, summary }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center">
      {/* backdrop */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/40 animate-[fadeIn_200ms_ease-out]"
      />
      {/* modal */}
      <div
        className="relative w-full sm:w-[520px] m-0 sm:m-4 rounded-2xl bg-white shadow-xl
                   animate-[popIn_220ms_cubic-bezier(0.22,1,0.36,1)]"
      >
        <div className="p-6">
          <div className="flex items-start gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-emerald-100">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-emerald-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div className="min-w-0">
              <h3 className="text-lg font-semibold text-slate-900">Cash booking issued!</h3>
              <p className="mt-1 text-sm text-slate-600">
                Tickets have been generated
                {summary?.buyer?.email ? <> and emailed to <b>{summary.buyer.email}</b></> : ""}.
              </p>
            </div>
          </div>

          <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
            <div className="rounded-lg border p-3">
              <div className="text-slate-500">Event</div>
              <div className="font-semibold text-slate-900 truncate">{summary?.eventName || "-"}</div>
            </div>
            <div className="rounded-lg border p-3">
              <div className="text-slate-500">Booking Code</div>
              <div className="font-semibold text-slate-900 truncate">{summary?.bookingCode || summary?.bookingId || "-"}</div>
            </div>
            <div className="rounded-lg border p-3">
              <div className="text-slate-500">Tickets</div>
              <div className="font-semibold text-slate-900">{summary?.totalTickets ?? 0}</div>
            </div>
            <div className="rounded-lg border p-3">
              <div className="text-slate-500">Amount</div>
              <div className="font-semibold text-slate-900">
                ₹{Number(summary?.amount || 0).toLocaleString("en-IN")}
              </div>
            </div>
          </div>

          {(summary?.assignee?.name || summary?.assignee?.mobile || summary?.assignee?.email) && (
            <div className="mt-3 text-xs text-slate-600">
              Issued by:&nbsp;
              <b>
                {summary?.assignee?.name || "-"}
              </b>
              {summary?.assignee?.mobile ? ` · ${summary.assignee.mobile}` : ""}
              {summary?.assignee?.email ? ` · ${summary.assignee.email}` : ""}
            </div>
          )}

          {summary?.buyer?.mobile && (
            <div className="mt-1 text-xs text-slate-500">
              SMS/WhatsApp can be sent to <b>{summary.buyer.mobile}</b> (if configured).
            </div>
          )}

          <div className="mt-6 flex flex-col-reverse sm:flex-row gap-2">
            <button
              onClick={onNew}
              className="inline-flex flex-1 justify-center rounded-xl border px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
            >
              New Cash Booking
            </button>
            <button
              onClick={onView}
              className="inline-flex flex-1 justify-center rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-slate-800"
            >
              View Booking
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes popIn {
          0% { opacity: 0; transform: translateY(16px) scale(.96) }
          100% { opacity: 1; transform: translateY(0) scale(1) }
        }
      `}</style>
    </div>
  );
}

/* ----------------- main ----------------- */
export default function AdminCashBooking() {
  const navigate = useNavigate();

  // events + selection
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState("");
  const [event, setEvent] = useState(null);
  const [loadingEvent, setLoadingEvent] = useState(false);

  // buyer (customer)
  const [buyer, setBuyer] = useState({ name: "", email: "", mobile: "" });

  // assignee (counter staff / admin)
  const [assignee, setAssignee] = useState({ name: "", email: "", mobile: "" });

  // lines
  const [lines, setLines] = useState([
    { categoryId: "", price: "", quantity: 1, hintSeats: null, userPriceOverride: false },
  ]);

  // discount / notes / idempotency
  const [discount, setDiscount] = useState({ code: "", mode: "flat", value: "" });
  const [notes, setNotes] = useState("");
  /** bulk = one ticket for qty N; single = N separate tickets / barcodes */
  const [ticketIssueMode, setTicketIssueMode] = useState("bulk");
  const [idKey, setIdKey] = useState(uuid());

  const [submitting, setSubmitting] = useState(false);

  // success modal
  const [successOpen, setSuccessOpen] = useState(false);
  const [successSummary, setSuccessSummary] = useState(null);

  /* ------------- fetch events list ------------- */
  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const data = await get(API.events.getEvent || API.events.list || "/api/events", {
          headers: { Authorization: token ? `Bearer ${token}` : undefined },
        }).catch(() => ({ events: [] }));
        const arr = data?.events || data || [];
        if (!on) return;
        setEvents(arr);
      } catch {
        setEvents([]);
      }
    })();
    return () => { on = false; };
  }, []);

  /* ------------- fetch single event when chosen ------------- */
  useEffect(() => {
    if (!eventId) { setEvent(null); return; }
    let on = true;
    (async () => {
      try {
        setLoadingEvent(true);
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const data = await get(`${API.events.getSinglEvent}/${eventId}`, {
          headers: { Authorization: token ? `Bearer ${token}` : undefined },
        });
        if (!on) return;
        setEvent(data?.event || null);
        const first = data?.event?.ticketCategories?.[0];
        setLines([{
          categoryId: first?.type || "",
          price: first?.price || "",
          quantity: 1,
          hintSeats: first?.availableSeats ?? null,
          userPriceOverride: false,
        }]);
      } catch {
        setEvent(null);
      } finally {
        setLoadingEvent(false);
      }
    })();
    return () => { on = false; };
  }, [eventId]);

  const categories = useMemo(() => event?.ticketCategories || [], [event]);

  /* ------------- line updates (auto-price sync) ------------- */
  const updateLine = (i, patch) => {
    setLines((prev) => {
      const next = [...prev];
      const merged = { ...next[i], ...patch };

      if ("categoryId" in patch) {
        const evCat = categories.find((c) => c.type === patch.categoryId);
        merged.price = evCat?.price ?? "";
        merged.hintSeats = evCat?.availableSeats ?? null;
        merged.userPriceOverride = false;
      }
      if ("price" in patch) merged.userPriceOverride = true;
      if ("quantity" in patch) merged.quantity = Math.max(1, Number(merged.quantity || 1));

      next[i] = merged;
      return next;
    });
  };

  const removeLine = (i) => setLines((prev) => prev.filter((_, idx) => idx !== i));

  const addLine = () => {
    const used = new Set(lines.map((l) => l.categoryId).filter(Boolean));
    const nextCat = categories.find((c) => !used.has(c.type)) || categories[0];
    setLines((prev) => [
      ...prev,
      {
        categoryId: nextCat?.type || "",
        price: nextCat?.price || "",
        quantity: 1,
        hintSeats: nextCat?.availableSeats ?? null,
        userPriceOverride: false,
      },
    ]);
  };

  /* ------------- totals ------------- */
  const subtotal = useMemo(
    () => lines.reduce((s, l) => s + Number(l.quantity || 0) * Number(l.price || 0), 0),
    [lines]
  );

  const discountRaw = Number(discount.value || 0);
  const percent = discount.mode === "percent" ? Math.max(0, Math.min(100, discountRaw)) : 0;
  const discountValue =
    discount.mode === "percent"
      ? Math.round((subtotal * percent) / 100)
      : Math.max(0, Math.min(subtotal, Number(discount.value || 0)));
  const total = Math.max(0, subtotal - discountValue);

  /* ------------- client validation ------------- */
  const valid =
    eventId &&
    lines.length > 0 &&
    lines.every((l) => l.categoryId && Number(l.quantity) > 0 && Number(l.price) >= 0) &&
    ((buyer.email && /\S+@\S+\.\S+/.test(buyer.email)) || (buyer.mobile && /^\d{10}$/.test(buyer.mobile)));
    // NOTE: assignee optional; agar required chahiye to yaha add karein:
    // && (assignee.name || assignee.email || assignee.mobile)

  /* ------------- submit ------------- */
  const onSubmit = async (e) => {
    e.preventDefault();
    if (!valid) { toast.error("Please complete required fields properly."); return; }
    setSubmitting(true);
    try {
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;

      const payload = {
        user: { name: buyer.name, email: buyer.email, mobile: buyer.mobile },
        // NEW: assignee
        assignee: assignee?.name || assignee?.email || assignee?.mobile
          ? { name: assignee.name, email: assignee.email, mobile: assignee.mobile }
          : undefined,
        eventId,
        categories: lines.map((l) => ({
          categoryId: l.categoryId,
          quantity: Number(l.quantity || 0),
          price: Number(l.price || 0),
        })),
        discount:
          discountValue > 0
            ? {
                code: discount.code || undefined,
                value: discountValue,
                meta: discount.mode === "percent" ? { mode: "percent", raw: discountRaw } : undefined,
              }
            : undefined,
        notes: notes || undefined,
        issueType: "offline",
        ticketIssueMode, // "single" | "bulk"
        idempotencyKey: idKey,
      };

      const resp = await post(API.Payment.createCashBooking, payload, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      });

      if (resp?.success) {
        toast.success(
          resp.idempotent
            ? "Already issued (idempotent)"
            : resp.ticketIssueMode === "single"
              ? `Issued ${resp.issuedCount || lines.reduce((s, l) => s + Number(l.quantity || 0), 0)} single tickets`
              : "Cash booking created!"
        );

        const booking = resp.booking || {};
        const tickets = resp.tickets || {};
        const eventName =
          booking?.eventId?.name ||
          events.find((e) => (e._id || e.id) === eventId)?.name ||
          "";

        const totalTickets =
          Number(resp.issuedCount) ||
          (tickets?.ticketCategories || []).reduce(
            (sum, c) => sum + Number(c.finalQuantity || 0),
            0
          ) ||
          lines.reduce((s, l) => s + Number(l.quantity || 0), 0);

        setSuccessSummary({
          eventName,
          bookingCode: booking?.bookingCode,
          bookingId: booking?._id,
          amount: resp?.payment?.finalAmount ?? booking?.finalAmount ?? 0,
          buyer: { name: buyer.name, email: buyer.email, mobile: buyer.mobile },
          assignee: { name: assignee.name, email: assignee.email, mobile: assignee.mobile },
          totalTickets,
        });
        setSuccessOpen(true);

        // reset on modal "New Cash Booking" click
      } else {
        throw new Error(resp?.message || "Failed to create cash booking");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    } finally {
      setSubmitting(false);
      setIdKey(uuid()); // refresh
    }
  };

  // reset all fields helper
  const resetForm = (resetEventToo = true) => {
    setBuyer({ name: "", email: "", mobile: "" });
    setAssignee({ name: "", email: "", mobile: "" });
    setNotes("");
    setTicketIssueMode("bulk");
    setDiscount({ code: "", mode: "flat", value: "" });
    setLines([{ categoryId: "", price: "", quantity: 1, hintSeats: null, userPriceOverride: false }]);
    setIdKey(uuid());
    if (resetEventToo) {
      setEventId("");
      setEvent(null);
    } else {
      const first = event?.ticketCategories?.[0];
      if (first) {
        setLines([{
          categoryId: first.type,
          price: first.price || "",
          quantity: 1,
          hintSeats: first?.availableSeats ?? null,
          userPriceOverride: false,
        }]);
      }
    }
  };

  return (
    <form onSubmit={onSubmit} className={cn(AD.formWrapWide, AD.page)}>
      <div className={AD.headerRow}>
        <div>
          <nav className="mb-1 flex items-center gap-1.5 text-xs text-slate-500">
            <span>Admin</span>
            <span>/</span>
            <span className="font-medium text-slate-700">Cash booking</span>
          </nav>
          <h1 className={AD.title}>Cash booking</h1>
          <p className={AD.subtitle}>Issue tickets at the counter and record cash payment.</p>
        </div>
        <div className={AD.toolbar}>
          <Chip tone="blue">Key: {idKey.slice(0, 8)}…</Chip>
          <button type="button" onClick={() => setIdKey(uuid())} className={AD.btnSecondary}>
            New key
          </button>
          <Link to="/admin/allBookingList" className={AD.btnSecondary}>
            All bookings
          </Link>
        </div>
      </div>

      <div className="grid gap-6 lg:grid-cols-[1fr_360px]">
        <div className="space-y-6">
          <div className={AD.formSurface}>
            <div className="mb-3 flex items-center justify-between">
              <h2 className="text-base font-semibold text-slate-900">Event</h2>
              {loadingEvent && <span className="text-xs text-slate-500">loading…</span>}
            </div>
            <Select label="Select event" value={eventId} onChange={(e) => setEventId(e.target.value)}>
              <option value="">— Choose an event —</option>
              {events.map((ev) => (
                <option key={ev._id || ev.id} value={ev._id || ev.id}>
                  {ev.name || ev.title}
                </option>
              ))}
            </Select>

            {event && (
              <div className="mt-4 flex flex-wrap items-center gap-2 text-sm">
                <Chip>{formatEventDateTime(event.date)}</Chip>
                {event.venue?.name && <Chip tone="green">{event.venue.name}</Chip>}
                {event.status && <Chip tone="amber">{event.status}</Chip>}
              </div>
            )}
          </div>

          <div className={AD.formSurface}>
            <h2 className="mb-3 text-base font-semibold text-slate-900">Buyer</h2>
            <div className="grid gap-4 sm:grid-cols-3">
              <Text label="Full Name" placeholder="e.g. Rohan Singh" value={buyer.name}
                onChange={(e) => setBuyer((b) => ({ ...b, name: e.target.value }))} />
              <Text label="Email" type="email" placeholder="you@example.com" value={buyer.email}
                onChange={(e) => setBuyer((b) => ({ ...b, email: e.target.value }))} />
              <Text label="Mobile (10-digit)" inputMode="numeric" maxLength={10} placeholder="98XXXXXXXX"
                value={buyer.mobile}
                onChange={(e) => setBuyer((b) => ({ ...b, mobile: e.target.value.replace(/\D/g, "").slice(0, 10) }))} />
            </div>
            <p className="mt-2 text-xs text-slate-500">Need at least email or mobile to deliver tickets.</p>
          </div>

          <div className={AD.formSurface}>
            <h2 className="mb-3 text-base font-semibold text-slate-900">Assignee (issued by)</h2>
            <div className="grid gap-4 sm:grid-cols-3">
              <Text label="Name" placeholder="e.g. Cashier / Staff" value={assignee.name}
                onChange={(e) => setAssignee((a) => ({ ...a, name: e.target.value }))} />
              <Text label="Email (optional)" type="email" placeholder="staff@example.com" value={assignee.email}
                onChange={(e) => setAssignee((a) => ({ ...a, email: e.target.value }))} />
              <Text label="Mobile (optional)" inputMode="numeric" maxLength={10} placeholder="98XXXXXXXX"
                value={assignee.mobile}
                onChange={(e) => setAssignee((a) => ({ ...a, mobile: e.target.value.replace(/\D/g, "").slice(0, 10) }))} />
            </div>
            <p className="mt-2 text-xs text-slate-500">
              Optional: who issued this cash booking (for audit).
            </p>
          </div>

          <div className={AD.formSurface}>
            <div className="mb-3 flex items-center justify-between">
              <h2 className="text-base font-semibold text-slate-900">Ticket Categories</h2>
            </div>

            <div className="mb-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
              <button
                type="button"
                onClick={() => setTicketIssueMode("single")}
                className={cn(
                  "rounded-lg border px-3 py-3 text-left transition",
                  ticketIssueMode === "single"
                    ? "border-amber-500 bg-amber-50 ring-1 ring-amber-400"
                    : "border-slate-300 bg-white hover:border-amber-300"
                )}
              >
                <div className="text-sm font-semibold text-slate-900">Single ticket</div>
                <div className="mt-0.5 text-xs text-slate-500">
                  Qty N → N separate tickets (separate QR each)
                </div>
              </button>
              <button
                type="button"
                onClick={() => setTicketIssueMode("bulk")}
                className={cn(
                  "rounded-lg border px-3 py-3 text-left transition",
                  ticketIssueMode === "bulk"
                    ? "border-amber-500 bg-amber-50 ring-1 ring-amber-400"
                    : "border-slate-300 bg-white hover:border-amber-300"
                )}
              >
                <div className="text-sm font-semibold text-slate-900">Bulk ticket</div>
                <div className="mt-0.5 text-xs text-slate-500">
                  Qty N → one ticket for N people (one QR)
                </div>
              </button>
            </div>

            <div className="mb-3 flex items-center justify-between gap-2">
              <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                Ticket category
              </h3>
              <button
                type="button"
                onClick={addLine}
                disabled={!categories.length}
                className="rounded-lg border border-slate-300 bg-white px-2.5 py-1 text-xs font-semibold text-slate-700 hover:bg-amber-50 disabled:opacity-50"
              >
                + Add
              </button>
            </div>

            <div className="space-y-3">
              {lines.map((l, i) => {
                const evCat = categories.find((c) => c.type === l.categoryId);
                const seatLeft = evCat?.availableSeats ?? l.hintSeats;
                const over = seatLeft != null && Number(l.quantity || 0) > Number(seatLeft);

                return (
                  <div key={i} className="rounded-xl border p-4">
                    <div className="grid gap-3 sm:grid-cols-[1.3fr_1fr_1fr_auto] sm:items-end">
                      <Select label="Category" value={l.categoryId} onChange={(e) => updateLine(i, { categoryId: e.target.value })}>
                        <option value="">— choose —</option>
                        {categories.map((c) => (
                          <option key={c.type} value={c.type}>
                            {c.type} {c.price ? `• ${fmtInr(c.price)}` : ""}
                          </option>
                        ))}
                      </Select>

                      <Text label="Price (each)" type="number" min="0" value={l.price}
                        onChange={(e) => updateLine(i, { price: e.target.value })} />

                      <Text label="Quantity" type="number" min="1" value={l.quantity}
                        onChange={(e) => updateLine(i, { quantity: e.target.value })} />

                      <div className="flex items-center justify-between gap-3">
                        <div className="text-sm font-semibold text-slate-900">
                          {fmtInr((Number(l.price || 0) * Number(l.quantity || 0)) || 0)}
                        </div>
                        <button type="button" onClick={() => removeLine(i)}
                          className="rounded-full border px-3 py-1.5 text-xs text-rose-600 hover:bg-rose-50">
                          Remove
                        </button>
                      </div>
                    </div>

                    <div className="mt-2 flex items-center justify-between text-xs">
                      <div className="space-x-2">
                        {seatLeft != null && <Chip tone={over ? "red" : "slate"}>Seats left: {seatLeft}</Chip>}
                        {evCat?.perks?.length ? <Chip tone="blue">{evCat.perks.join(", ")}</Chip> : null}
                        {l.userPriceOverride && <Chip tone="amber">price overridden</Chip>}
                      </div>
                      {over && <div className="text-rose-600 font-medium">Insufficient seats in this category</div>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Discount / Notes */}
          <div className="rounded-2xl border bg-white p-5">
            <h2 className="mb-3 text-base font-semibold text-slate-900">Discount & Notes</h2>
            <div className="grid gap-4 sm:grid-cols-4">
              <Text label="Discount Code (optional)" value={discount.code}
                onChange={(e) => setDiscount((d) => ({ ...d, code: e.target.value }))} />
              <Select label="Mode" value={discount.mode}
                onChange={(e) => setDiscount((d) => ({ ...d, mode: e.target.value }))}>
                <option value="flat">Flat (₹)</option>
                <option value="percent">Percent (%)</option>
              </Select>
              <Text label={discount.mode === "percent" ? "Discount (%)" : "Discount Amount (₹)"}
                type="number" min="0" max={discount.mode === "percent" ? "100" : undefined}
                value={discount.value}
                onChange={(e) => setDiscount((d) => ({ ...d, value: e.target.value }))} />
              <Text label="Notes (internal)" value={notes} onChange={(e) => setNotes(e.target.value)} />
            </div>
            {discount.mode === "percent" && !!discount.value && (
              <p className="mt-2 text-xs text-slate-600">
                Applying {Math.max(0, Math.min(100, Number(discount.value || 0)))}% on {fmtInr(subtotal)} → <b>{fmtInr(discountValue)}</b>
              </p>
            )}
          </div>
        </div>

        {/* RIGHT: summary */}
        <aside className="space-y-6 lg:sticky lg:top-4 lg:self-start">
          <div className={AD.formSurface}>
            <h3 className="mb-4 text-base font-semibold text-slate-900">Review</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-center justify-between">
                <span className="text-slate-600">Issue mode</span>
                <span className="font-semibold text-slate-900">
                  {ticketIssueMode === "single" ? "Single" : "Bulk"}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-slate-600">Subtotal</span>
                <span className="font-semibold text-slate-900">{fmtInr(subtotal)}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-slate-600">Discount</span>
                <span className="font-semibold text-emerald-700">− {fmtInr(discountValue)}</span>
              </div>
              <div className="border-t pt-3 flex items-center justify-between">
                <span className="text-slate-900 font-semibold">Total</span>
                <span className="text-lg font-bold text-slate-900">{fmtInr(total)}</span>
              </div>
            </div>

            <div className="mt-4 rounded-xl bg-slate-50 p-3 text-xs text-slate-600">
              <ul className="list-disc pl-4 space-y-1">
                <li>Payment method recorded as <b>cash</b>.</li>
                <li>
                  <b>Single</b>: qty N → N separate QRs. <b>Bulk</b>: qty N → one QR.
                </li>
                <li>Tickets & PDF emailed if buyer email is provided.</li>
                <li>Idempotency prevents duplicate issue if you re-submit.</li>
              </ul>
            </div>

            <button
              type="submit"
              disabled={!valid || submitting}
              className={cn(
                AD.btnPrimary,
                "mt-4 w-full",
                (!valid || submitting) && "cursor-not-allowed opacity-50"
              )}
            >
              {submitting ? "Issuing…" : "Confirm & issue"}
            </button>
          </div>

          {event && (
            <div className={AD.formSurface}>
              <h3 className="mb-3 text-base font-semibold text-slate-900">Availability</h3>
              <div className="space-y-2">
                {event.ticketCategories?.map((c) => (
                  <div key={c.type} className="flex items-center justify-between text-sm">
                    <span className="text-slate-700">{c.type}</span>
                    <div className="flex items-center gap-2">
                      <Chip tone="green">{fmtInr(c.price)}</Chip>
                      <Chip tone={(c.availableSeats ?? 0) > 0 ? "slate" : "red"}>
                        {c.availableSeats ?? 0} left
                      </Chip>
                    </div>
                  </div>
                ))}
                {!event.ticketCategories?.length && (
                  <div className="text-sm text-slate-500">No ticket categories configured.</div>
                )}
              </div>
            </div>
          )}
        </aside>
      </div>

      {/* success modal */}
      <SuccessModal
        open={successOpen}
        summary={successSummary}
        onClose={() => setSuccessOpen(false)}
        onNew={() => {
          setSuccessOpen(false);
          resetForm(true); // pass false if you want to keep selected event
        }}
        onView={() => {
          setSuccessOpen(false);
          if (successSummary?.bookingId) {
            navigate(`/admin/bookings/${successSummary.bookingId}`, { replace: true });
          } else {
            navigate(`/admin/bookings`, { replace: true });
          }
        }}
      />
    </form>
  );
}


